<template>
    <div>
        <div class="mb-3 text-right">
            <hts-form-button
                v-if="checkPermission(layoutPermissions.remooc_add)"
                color="main"
                icon-name="hi-plus-circle-icon"
                icon-position="right"
                type="submit"
                @click="handleAddRemooc">
                {{ $t('labels.remoocModule.add') }}
            </hts-form-button>
        </div>
        <hts-data-table
            ref="dataTables"
            :headers="vehiclesHeaders"
            :server="apiListRemooc"
            :use-archive="apiArchive"
            :use-restore="apiRestore"
            use-selection
            store-name="vehicleDataTable"
            store-key="VehicleRemooc" />
        <add-remooc
            ref="showDrawerAddRemooc"
            :column="2"
            @refresh-tables="refreshTables()" />
        <edit-remooc
            ref="showDrawerEditRemooc"
            :remooc-info="remoocIsSelectedToEdit"
            :column="2"
            :check-disabled-edit="checkDisabledEdit"
            @refresh-tables="refreshTables()" />
        <detail-remooc
            ref="showDrawerDetailRemooc"
            :remooc-info="remoocIsSelectedToEdit"
            :column="2"
            :check-disabled-edit="checkDisabledEdit"
            @refresh-tables="refreshTables()" />
        <document
            :id="remoocId"
            ref="showDrawerDocumentRemooc"
            type="remooc"
            :reload="isReload" />
        <hts-modal
            :show="showPopupDeleteRemooc"
            :title="$t('labels.remoocModule.delete')"
            type="confirm"
            :content="$t('labels.remoocModule.confirm')"
            @hide="closePopupDeleteRemooc"
            @confirm="() => actionDeleteRemooc()" />
    </div>
</template>

<script lang="ts" setup>
import Actions from './ignore/actions.vue'
import Document from './ignore/remooc-document/document.vue'
import AddRemooc from './ignore/remooc/add-remooc.vue'
import DetailRemooc from './ignore/remooc/detail.vue'
import EditRemooc from './ignore/remooc/edit-remooc.vue'
import StatusComponent from '~/components/status.vue'
import { checkPermission } from '@/utils/permission-check'
import layoutPermissions from '@/data/permissions/layout-permissions'
const route = useRoute()

const { $formatters } = useNuxtApp()

const dataTables = ref()
const remoocIsSelectedToEdit = reactive({})
const showDrawerAddRemooc: any = ref(false)
const showDrawerEditRemooc: any = ref()
const showDrawerDetailRemooc: any = ref()
const showDrawerDocumentRemooc: any = ref()
const checkDisabledEdit = ref(true)
const remoocId = ref('')
const showPopupDeleteRemooc = ref(false)
const remoocIsSelectedToDelete = ref('')
const isReload = ref(false)

const apiListRemooc = $url.vehicle.remooc.getList

const handleAddRemooc = () => {
  if (showDrawerAddRemooc.value) {
    showDrawerAddRemooc.value.openAddRemooc()
  }
}
const handleViewDocument = (remooc: any) => {
  if (!remooc) {
    return null
  }
  remoocId.value = remooc._id
  if (showDrawerDocumentRemooc.value) {
    showDrawerDocumentRemooc.value.openDrawerDocument(remooc._id)
  }
}
const handleEditRemooc = (remooc: any) => {
  if (!remooc) {
    return null
  }
  Object.assign(remoocIsSelectedToEdit, { ...remooc })
  if (showDrawerEditRemooc.value) {
    showDrawerEditRemooc.value.openEditRemooc(remoocIsSelectedToEdit)
  }
}

const handleViewDetail = (remooc: any) => {
  if (!remooc) {
    return null
  }
  Object.assign(remoocIsSelectedToEdit, { ...remooc })
  if (showDrawerEditRemooc.value) {
    showDrawerDetailRemooc.value.openEditRemooc(remoocIsSelectedToEdit)
  }
}

const handleDeleteRemooc = (remooc: any) => {
  if (!remooc) {
    return null
  }
  showPopupDeleteRemooc.value = true
  remoocIsSelectedToDelete.value = remooc._id
}
const vehiclesHeaders = [
  {
    field: 'remoocCategoryDetail.name',
    headerName: $t('labels.remoocModule.remoocType'),
    sortable: true
  },
  {
    field: 'licensePlate',
    filter: 'agTextColumnFilter',
    headerName: $t('labels.remoocModule.licensePlate'),
    sortable: true
  },
  {
    field: 'manufacture',
    filter: 'agTextColumnFilter',
    headerName: $t('labels.remoocModule.manufacture')
  },
  {
    field: 'approvedByManagement',
    headerName: $t('labels.administrationStatus'),
    cellRenderer: StatusComponent,
    cellRendererParams: {
      module: 'vehicleManagementApprove',
      label: '',
      keyStatus: 'approvedByManagement'
    },
    filter: 'TableFilterStatus',
    filterItems: [
      { name: $t('labels.all'), value: null },
      { name: $t('labels.approved'), value: true, class: { '!bg-green-100': true, '!text-green-800': true } }, // Approved: Màu xanh lá cây
      { name: $t('labels.waittingApprove'), value: false, class: { '!bg-yellow-100': true, '!text-yellow-800': true } } // Waiting for Approval: Màu vàng
    ],
    filterModelDefault: { type: 'equals', filterType: 'boolean' }
  },
  {
    field: 'load',
    filter: 'agNumberColumnFilter',
    headerName: $t('labels.vehicleLoadByKg'),
    sortable: true,
    valueGetter: (params: any) => {
      if (!params) {
        return null
      }
      return $formatters.formatCurrency(params.data.load)
    }
  },
  // {
  //   field: 'coveringContainerLevel',
  //   label: 'coveringContainerLevel',
  //   headerName: $t('labels.remoocModule.remoocCategory.coveringContainerLevel'),
  //   sortable: true,
  //   valueGetter: (params: any) => {
  //     if (!params) {
  //       return null
  //     }
  //     if (params.data.coveringContainerLevel === CoveringContainerLevel.PRIVATE) {
  //       return $t('labels.remoocModule.remoocCategory.private')
  //     } else if (params.data.coveringContainerLevel === CoveringContainerLevel.OPEN) {
  //       return $t('labels.remoocModule.remoocCategory.open')
  //     }
  //   }
  // },
  // {
  //   field: 'goodsTypes',
  //   label: 'goodsTypes',
  //   headerName: $t('labels.remoocModule.remoocCategory.goodsTypes'),
  //   sortable: true,
  //   valueGetter: (params: any) => {
  //     if (!params) {
  //       return null
  //     }
  //     const goodsType = params.data.goodsType
  //     if (goodsType.length > 0) {
  //       const formatGoodsType = goodsType.map((item: any) => {
  //         if (item === '') {
  //           return item
  //         }
  //         if (item === GoodsTypes.SOLID) {
  //           item = $t('labels.remoocModule.remoocCategory.solid')
  //         } else if (item === GoodsTypes.LIQUID) {
  //           item = $t('labels.remoocModule.remoocCategory.liquid')
  //         } else {
  //           item = $t('labels.remoocModule.remoocCategory.gas')
  //         }
  //         return item
  //       })
  //       return formatGoodsType.toString()
  //     }
  //   }
  // },
  {
    field: 'isTowingContainer',
    headerName: $t('labels.remoocModule.remoocCategory.towingCapacity'),
    sortable: true,
    valueGetter: (params: any) => {
      if (!params) {
        return null
      }
      const { isTowingContainer } = params.data
      return isTowingContainer ? $t('labels.remoocModule.remoocCategory.isTowing') : $t('labels.remoocModule.remoocCategory.isNotTowing')
    }
  },
  {
    field: 'containerType',
    headerName: $t('labels.suitableContainerType'),
    sortable: true,
    valueGetter: (params: any) => {
      if (!params.data.towingCapacity || !params.data.towingCapacity.length || !params.data.isTowingContainer) {
        return null
      }
      const result: { [key: string]: any } = []
      params.data.towingCapacity.forEach((i: string) => {
        if (listLabelCont[i]) {
          result.push(listLabelCont[i])
        }
      })
      return result.join(',')
    }
  },
  {
    field: 'price',
    filter: 'agNumberColumnFilter',
    headerName: $t('labels.remoocModule.price'),
    sortable: true,
    valueGetter: (params: any) => {
      if (!params) {
        return null
      }
      return $formatters.formatCurrency(params.data.price)
    }
  },
  {
    field: 'depreciation',
    filter: 'agNumberColumnFilter',
    headerName: $t('labels.depreciationPeriodRemoocByYear'),
    sortable: true
  },
  {
    field: 'sellingPrice',
    filter: 'agNumberColumnFilter',
    headerName: $t('labels.remoocModule.sellingPrice'),
    valueGetter: (params: any) => {
      if (!params) {
        return null
      }
      return $formatters.formatCurrency(params.data.sellingPrice)
    }
  },
  {
    field: 'status',
    headerName: 'Trạng thái gắn, gỡ',
    cellRenderer: StatusComponent,
    cellRendererParams: {
      module: 'remoocAssignStatus',
      label: '',
      keyStatus: 'status'
    },
    filter: 'TableFilterStatus',
    filterItems: [
      { name: $t('labels.all'), value: null },
      {
        name: $t('labels.remoocModule.active'),
        value: 1,
        class: { '!bg-green-100': true, '!text-green-800': true } // Active: Màu xanh lá cây
      },
      {
        name: $t('labels.remoocModule.inactive'),
        value: -1,
        class: { '!bg-red-100': true, '!text-red-800': true } // Inactive: Màu đỏ
      }
    ],
    filterModelDefault: { type: 'equals', filterType: 'number' }
  },
  {
    field: 'description',
    headerName: $t('labels.description'),
    sortable: true
  },
  {
    field: 'createdAt',
    filter: 'agDateColumnFilter',
    headerName: $t('labels.createdAt'),
    sortable: true,
    valueGetter: (params: any) => {
      if (params.data.createdAt) {
        return $formatters.datetime(params.data.createdAt)
      }
    }
  },
  {
    field: 'updatedAt',
    filter: 'agDateColumnFilter',
    headerName: $t('labels.updatedAt'),
    sortable: true,
    valueGetter: (params: any) => {
      if (params.data.updatedAt) {
        return $formatters.datetime(params.data.updatedAt)
      }
    }
  },
  {
    field: 'action',
    pinned: 'right',
    sortable: false,
    lockPosition: true,
    lockPinned: true,
    headerName: $t('labels.action'),
    cellStyle: { overflow: 'visible' },
    cellRenderer: Actions,
    cellRendererParams: {
      storeKey: 'vehicleDataTable',
      storeName: 'VehicleRemooc',
      items: [
        {
          icon: 'hi-eye-icon',
          label: $t('labels.viewDetail'),
          class: 'text-blue-600 hover:text-blue-500',
          click: handleViewDetail,
          permissions: checkPermission(layoutPermissions.remooc_management),
          isAll: true
        },
        {
          icon: 'hi-pencil-icon',
          label: $t('labels.edit'),
          class: 'text-blue-600 hover:text-blue-500',
          permissions: checkPermission(layoutPermissions.remooc_edit),
          click: handleEditRemooc
        },
        {
          icon: 'hi-eye-icon',
          label: $t('labels.viewDocument'),
          class: 'text-blue-600 hover:text-blue-500',
          permissions: checkPermission(layoutPermissions.remooc_document_management),
          click: handleViewDocument
        },
        {
          icon: 'hi-trash-icon',
          label: $t('labels.delete'),
          class: 'text-error-600 hover:text-error-500',
          permissions: checkPermission(layoutPermissions.remooc_delete),
          click: handleDeleteRemooc,
          isArchive: true
        }
      ]
    }
  }
]

const closePopupDeleteRemooc = () => {
  showPopupDeleteRemooc.value = false
  Object.assign(remoocIsSelectedToDelete, {})
}

const actionDeleteRemooc = () => {
  const api = $url.vehicle.remooc.delete
  $api(api, { body: { id: remoocIsSelectedToDelete.value } }).then((data: any) => {
    const resData: any = data.data.value
    if (resData.success) {
      dataTables.value.refresh()
      showPopupDeleteRemooc.value = false
      process.client && $toast().success(resData.data)
    }
  })
}

const refreshTables = () => {
  if (dataTables.value) {
    dataTables.value.refresh()
  }
}

const getInfoRemoocEdit = (remoocId: string) => {
  const apiRemoocDetail = $url.vehicle.remooc.getById

  $api(apiRemoocDetail, { uriParams: { ID: remoocId } }).then((data: any) => {
    const resData: any = data.data.value
    if (resData.success) {
      Object.assign(remoocIsSelectedToEdit, { ...resData.data })
      if (showDrawerEditRemooc.value) {
        showDrawerEditRemooc.value.openEditRemooc(remoocIsSelectedToEdit)
      }
    }
  })
}

onMounted(() => {
  const id: string = route.query.id ? String(route.query.id) : ''
  if (id) {
    getInfoRemoocEdit(id)
    checkDisabledEdit.value = false
  }
})

const listLabelCont: { [key: string]: any } = {
  10: $t('labels.vehicleModule.10ft'),
  20: $t('labels.vehicleModule.20ft'),
  40: $t('labels.vehicleModule.40ft'),
  45: $t('labels.vehicleModule.45ft'),
  50: $t('labels.vehicleModule.other')
}

const apiArchive = computed(() => {
  return { api: $url.vehicle.remooc.archive, permissions: checkPermission(layoutPermissions.remooc_archive) }
})

const apiRestore = computed(() => {
  return { api: $url.vehicle.remooc.restore, permissions: checkPermission(layoutPermissions.remooc_restore) }
})
</script>
